// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chetty-pulse {
        animation: none !important;
    }
    #chetty-chatbot-button {
        color: var(--tertiary-color);
        box-shadow: 0px 4px 11.5px 0px #545F92;
        filter: none !important;
        width: 210px !important;
        height: 56px !important;
        border-radius: 42px !important;
        background-image: var(--chetty-button-bg-url) !important;
        background-position: left center !important;
        background-size: cover !important;
        font-weight: 700;
        font-size: 14px !important;
        line-height: 24px;
        letter-spacing: 0.05em;
        text-align: center;
        text-transform: uppercase;
        padding-inline-start: 42px !important;
        position: fixed !important;
        bottom: 16px !important;
        right: 16px !important;
        border: none;
        justify-content: center;
        align-items: center;
    }
    #chetty-chatbot-button:not(.pulse) {
            display: none !important;
        }
    #chetty-chatbot-button > svg {
            display: none;
        }
    #chetty-chatbot-iframe {
        bottom: 16px !important;
        right: 16px !important;
    }

.AppLayout__root--wIIB {
    position: relative;
    margin: 0 auto;
    width: 100%;
    background-color: var(--main-light-color);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.AppLayout__main--x3up {
    width: 100%;
    max-width: var(--content-max-width);
    margin: 0 auto;
    padding: 24px 16px;
}

@media screen and (min-width: 1024px) {

.AppLayout__main--x3up {
        padding: 44px 0
}
    }

.AppLayout__footer--z3dH {
    margin-top: auto;
}

.AppLayout__currentScreen--xQ5u {
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100vw;
    height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/ui/layouts/AppLayout/AppLayout.css"],"names":[],"mappings":"AACI;QACI,0BAA0B;IAC9B;IAEA;QACI,4BAA4B;QAC5B,sCAAsC;QACtC,uBAAuB;QACvB,uBAAuB;QACvB,uBAAuB;QACvB,8BAA8B;QAC9B,wDAAwD;QACxD,2CAA2C;QAC3C,iCAAiC;QACjC,gBAAgB;QAChB,0BAA0B;QAC1B,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;QAClB,yBAAyB;QACzB,qCAAqC;QACrC,0BAA0B;QAC1B,uBAAuB;QACvB,sBAAsB;QACtB,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;IASvB;IAPI;YACI,wBAAwB;QAC5B;IAEA;YACI,aAAa;QACjB;IAGJ;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;AAGJ;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yCAAyC;IACzC,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,cAAc;IACd,kBAAkB;AAKtB;;AAHI;;AANJ;QAOQ;AAER;IADI;;AAGJ;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;AACjB","sourcesContent":[":global {\n    .chetty-pulse {\n        animation: none !important;\n    }\n\n    #chetty-chatbot-button {\n        color: var(--tertiary-color);\n        box-shadow: 0px 4px 11.5px 0px #545F92;\n        filter: none !important;\n        width: 210px !important;\n        height: 56px !important;\n        border-radius: 42px !important;\n        background-image: var(--chetty-button-bg-url) !important;\n        background-position: left center !important;\n        background-size: cover !important;\n        font-weight: 700;\n        font-size: 14px !important;\n        line-height: 24px;\n        letter-spacing: 0.05em;\n        text-align: center;\n        text-transform: uppercase;\n        padding-inline-start: 42px !important;\n        position: fixed !important;\n        bottom: 16px !important;\n        right: 16px !important;\n        border: none;\n        justify-content: center;\n        align-items: center;\n\n        &:not(.pulse) {\n            display: none !important;\n        }\n\n        > svg {\n            display: none;\n        }\n    }\n\n    #chetty-chatbot-iframe {\n        bottom: 16px !important;\n        right: 16px !important;\n    }\n}\n\n.root {\n    position: relative;\n    margin: 0 auto;\n    width: 100%;\n    background-color: var(--main-light-color);\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.main {\n    width: 100%;\n    max-width: var(--content-max-width);\n    margin: 0 auto;\n    padding: 24px 16px;\n\n    @media (--large) {\n        padding: 44px 0;\n    }\n}\n\n.footer {\n    margin-top: auto;\n}\n\n.currentScreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    width: 100vw;\n    height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AppLayout__root--wIIB`,
	"main": `AppLayout__main--x3up`,
	"footer": `AppLayout__footer--z3dH`,
	"currentScreen": `AppLayout__currentScreen--xQ5u`
};
export default ___CSS_LOADER_EXPORT___;
